<template>
    <div class="card">
        <div class="rank-list">
            <div class="rank-title">重点地区网电事件排行</div>
            <div class="table-header">
                <span>国家地区</span>
                <span>事件指数</span>
                <span>威胁程度</span>
            </div>
            <div class="rank-item" v-for="item in list" :key="item.name">
                <span class="name">{{ item.name }}</span>
                <span class="index">{{ item.index }}</span>
                <span class="status" :class="item.statusClass">{{ item.status }}</span>
            </div>
        </div>

    </div>
</template>

<script setup>
const list = [
    { name: '美国', index: '9.1', status: '非常严重', statusClass: 'red' },
    { name: '加拿大', index: '7.1', status: '非常严重', statusClass: 'red' },
    { name: '澳大利亚', index: '7.1', status: '非常严重', statusClass: 'red' },
    { name: '英国', index: '6.1', status: '严重', statusClass: 'yellow' },
    { name: '德国', index: '5.5', status: '严重', statusClass: 'yellow' },
    { name: '法国', index: '5.2', status: '严重', statusClass: 'yellow' },
    { name: '俄罗斯', index: '5.1', status: '严重', statusClass: 'yellow' },
    { name: '伊朗', index: '5.0', status: '严重', statusClass: 'yellow' },
    { name: '日本', index: '4.5', status: '正常', statusClass: 'green' },
]
</script>

<style scoped>
.rank-list {
    background: rgba(0, 102, 204, 0.15);
    border: 1px solid #0e4c80;
    padding: 12px;
    border-radius: 6px;
    color: #ffffff;
}

.rank-title {
    font-size: 16px;
    font-weight: bold;
    color: #00ccff;
    margin-bottom: 10px;
}

.table-header,
.rank-item {
    display: flex;
    justify-content: space-between;
    padding: 6px 0;
    font-size: 13px;
}

.table-header {
    font-weight: bold;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.rank-item+.rank-item {
    border-top: 1px dashed rgba(255, 255, 255, 0.1);
}

.status.red {
    color: red;
}
.status.yellow {
    color: yellow;
}
.status.green {
    color: #00ff88;
}
</style>